import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

/** Outer column: centered result content with max width and vertical padding. */
export const SubscriptionResultRoot = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(3),
  maxWidth: 480,
  margin: '0 auto',
  padding: theme.spacing(10, 3),
}));

/** Responsive primary actions row (stacked on xs, row on sm+). */
export const SubscriptionResultButtonRow = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  flexDirection: 'column',
  width: '100%',
  '& > *': {
    flex: 1,
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    '& > *': {
      flex: '0 0 auto',
    },
  },
}));
